import React from 'react'
import CommonInput from '../../../../common/Resusable/CommonInput'

const SlrSubmittedBySection = ({
	t,
	details,
	errors,
	onChange,
	agentCode,
	setAgentCode,
	agentCodeError,
	onAgentCodeFocus,
	onAgentCodeBlur,
	showDetails,
}) => {
	return (
		<div className='new-booking-container' id='slr-submitted-by-section'>
			<div className='form-container-shippingdetails'>
				<h3 className='page-sub-head-view-booking'>
					{t('BOOKING.SLR_SUBMITTED_BY')}
				</h3>
				<div className='form-container'>
					<div className='shipping-deparr-row'>
						<div className='form-group'>
							<CommonInput
								type='text'
								label={t('BOOKING.SLR_AGENT_CODE_PLACEHOLDER')}
								value={agentCode}
								onChange={(e) => setAgentCode(e.target.value)}
								onFocus={onAgentCodeFocus}
								onBlur={onAgentCodeBlur}
								maxLength={11}
								error={agentCodeError ? t(agentCodeError, { ns: 'errors' }) : ''}
							/>
						</div>
					</div>
					{showDetails && (
						<>
							<div className='shipping-deparr-row'>
								<div className='form-group'>
									<CommonInput
										type='text'
										label={t('COMMON.NAME')}
										value={details?.companyName || ''}
										onChange={(e) => onChange('name', e.target.value)}
										error={errors?.name ? t(errors.name, { ns: 'errors' }) : ''}
									/>
								</div>
								<div className='form-group'>
									<CommonInput
										type='text'
										label={t('COMMON.EMAIL')}
										value={details?.email || ''}
										onChange={(e) => onChange('email', e.target.value)}
										error={errors?.email ? t(errors.email, { ns: 'errors' }) : ''}
									/>
								</div>
							</div>
							<div className='shipping-deparr-row'>
								<div className='form-group'>
									<CommonInput
										type='text'
										inputMode='numeric'
										maxLength={15}
										label={t('COMMON.TEL_NO')}
										value={details?.contactNo || ''}
										onChange={(e) => onChange('phone', e.target.value)}
									/>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	)
}

export default SlrSubmittedBySection
